import React from "react";

export default (props) => {
  return (
    <input type="text" className="form-control" style={{ fontSize: 80, textAlign: "center", height: 150, backgroundColor: "rgba(76, 175, 80, 0)" }} defaultValue={props.number} disabled></input>
  );
};
